import React, { useState, useEffect, Fragment } from "react";
import {
  Col,
  Card,
  CardHeader,
  CardBody,
  Form,
  Row,
  DropdownMenu,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  Label,
  ModalFooter,
  Button,
} from "reactstrap";
import { useForm } from "react-hook-form";
import DataTable from "react-data-table-component";
import { H3, Breadcrumbs, H4, Btn } from "../../../AbstractElements";
import { Link, useLocation, useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import {
  addSetupCost,
  getclientpackage,
  postShowTemp,
  userswithoutsubscription,
} from "../../../CommonURL";
import {
  getDataWithToken,
  postDataWithToken,
  postMasterToken,
} from "../../../Utils/restUtils";
import { UserwithoutSubDataColumns } from "../../../Data/MockTable/TempData";
import Transparentspinner from "../../Common/loader/Transparentspinner";
import { Filter, Search } from "../../../Constant";
import IndustryFilter from "../../Common/Filters/IndustryFilter";
import SearchList from "../../../CommonElements/Search";
import { toast } from "react-toastify";
import { selectRoleId } from "../../../Redux/personalDetail";
import { useSelector } from "react-redux";

const CompanyCreatedListTable = () => {
  const roleId = useSelector(selectRoleId);
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = location.search;
  const params = new URLSearchParams(searchParams);
  const sortedBy = params.get("sortBy") || "";
  const sortedOrder = params.get("sortOrder") || "";
  const searchKey = params.get("search") || "";
  const [filters, setFilters] = useState({
    search: searchKey,
    industry_id: "",
  });
  const [sortConfig, setSortConfig] = useState({
    column: sortedBy,
    order: sortedOrder,
  });
  const [tempList, setTempList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [isIndustry, setIsIndustry] = useState("");
  const [showPlanModal, setShowPlanModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [packageOptions, setPackageOptions] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [dateRange, setDateRange] = useState([]);
  const [startDate, endDate] = dateRange;
  const { register, setValue, handleSubmit } = useForm({
    defaultValues: {
      search: filters.search,
      industry_id: isIndustry?.value || "",
    },
  });

  useEffect(() => {
    fetchUsers(1);
  }, []);
  const toggleStyle = {
    padding: "10px 20px",
    opacity: "0.8",
    fontSize: "14px",
  };
  const UserwithoutSubDataColumns = [
    {
      name: <H4>Sl No</H4>,
      selector: (row) => row.Si,
      sortable: true,
      width: "70px",
      center:true
    },

    roleId === 1 && {
      name: <i className="fa fa-gears" style={{ fontSize: "15px" }}></i>,
      selector: (row) => row.action,
      cell: (row) => <ActionCell row={row} />,
      center: true,
      width: "55px",
    },
    {
      name: <H4>Name</H4>,
      selector: (row) => (
        <Link
          to={`${process.env.PUBLIC_URL}/subscriptions/company-list/userProfile?id=${row.Id}`}
        >
          {row.Name}
        </Link>
      ),
      sortable: true,
      width: "170px",
      wrap: true,
    },
    {
      name: <H4>Email</H4>,
      selector: (row) => row.Email,
      sortable: true,
      width: "230px",
      wrap: true,
    },
    {
      name: <H4>Phone No</H4>,
      selector: (row) => "+" + row.CountryCode + row.Mobile_Number,
      sortable: true,
      width: "170px",
      wrap: true,
    },
    {
      name: <H4>Industry Name</H4>,
      selector: (row) => row.Industry,
      sortable: true,
      width: "150px",
      wrap: true,
    },
    {
      name: <H4>Company Name</H4>,
      selector: (row) => row.Company,
      sortable: true,
      width: "150px",
      wrap: true,
    },
    {
      name: <H4>State</H4>,
      selector: (row) => row.State,
      sortable: true,
      width: "150px",
      wrap: true,
    },
    {
      name: <H4>Country</H4>,
      selector: (row) => row.Country,
      sortable: true,
      width: "100px",
      wrap: true,
    },
    {
      name: <H4>Created Date</H4>,
      selector: (row) => row.StartData,
      sortable: true,
      width: "180px",
      wrap: true,
    },
  ].filter(Boolean);
  const loadPackages = async (industryId, userId) => {
    try {
      const Postreq = {
        industry_type_id: industryId,
        user_id: userId,
      };
      const res = await postMasterToken(getclientpackage, Postreq);
      if (res?.data?.status === true) {
        const transformed = res.data.data.packages.map((pkg) => ({
          label: pkg.name,
          value: pkg.id,
          fullData: pkg,
        }));

        setPackageOptions(transformed);
      }
    } catch (err) {
      toast.error("Failed to load packages");
    }
  };
  const handleConfirmPlan = async () => {
    if (!selectedPlan) {
      toast.error("Please select a subscription plan");
      return;
    }

    if (!selectedUser) {
      toast.error("User data missing");
      return;
    }

    const requestBody = {
      package_id: selectedPlan.value,
      company_id: selectedUser.company_id,
      user_id: selectedUser.user_id,
      created_admin: "1",
    };

    try {
      const response = await postDataWithToken(addSetupCost, requestBody);
      if (response?.data?.status === true) {
        if (response?.data?.data === "free") {
          navigate(`${process.env.PUBLIC_URL}/subscriptions/active-sub`);
        } else {
          navigate(
            `${process.env.PUBLIC_URL}/companies/company-list/userProfile/invoice?order_id=${response?.data?.data?.order_id}`,
          );
        }
      } else {
        toast.error("Try again");
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong");
    } finally {
      setShowPlanModal(false);
    }
  };

  const handleCancel = () => {
    setShowPlanModal(false);
  };
  const ActionCell = ({ row }) => {
    const [dropdownOpen, setDropdownOpen] = React.useState(false);
    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    return (
      <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
        <DropdownToggle
          color="#00000"
          style={{ fontSize: "14px", zIndex: 1000 }}
        >
          <i className="fa fa-ellipsis-v"></i>
        </DropdownToggle>
        <DropdownMenu container="body">
          {row.CompanyId != null ? (
            <DropdownItem
              style={toggleStyle}
              onClick={() => redirectTopackage(row)}
            >
              Add Package
            </DropdownItem>
          ) : (
            <DropdownItem
              style={toggleStyle}
              onClick={() => handleCreateCompany(row)}
            >
              Create Company
            </DropdownItem>
          )}
        </DropdownMenu>
      </Dropdown>
    );
  };
  const redirectTopackage = (row) => {
    setSelectedUser({
      user_id: row.UserId,
      company_id: row.CompanyId,
      industry_id: row.industryID,
    });

    loadPackages(row.industryID, row.UserId);
    setShowPlanModal(true);
  };
  const handleCreateCompany = (row) => {
    navigate(`${process.env.PUBLIC_URL}/subscriptions/create-company`, {
      state: { bq_user_id: row.UserId },
    });
  };
  const fetchUsers = async (
    page,
    size = perPage,
    search = searchKeyword,
    industry_id = isIndustry?.value || "",
    start_date = startDate ? startDate.toISOString().split("T")[0] : "",
    end_date = endDate ? endDate.toISOString().split("T")[0] : "",
  ) => {
    setLoading(true);

    const response = await getDataWithToken(
      userswithoutsubscription +
        `?page=${page}
      &page_length=${size}
      &search=${search}
      &industry_type_id=${industry_id}
      &start_date=${start_date}
      &end_date=${end_date}`,
    );

    let serialNo = (page - 1) * size + 1;

    setTempList(
      response.data.data.map((e, index) => ({
        Si: serialNo + index,
        Name: (
          <span>
            {e.first_name} {e.last_name}
          </span>
        ),
        Id: e.id,
        Email: e.email,
        CountryCode: e.country_code,
        Mobile_Number: e.mobile,
        Industry: e.industry_name,
        Company: e.company,
        StartData: e.created_date,
        State: e.state,
        Country: e.country,
        industryID: e.industry_type_id,
        UserId: e.id,
        CompanyId: e.company_id,
      })),
    );

    setTotalRows(response.data.total);
    setLoading(false);
  };

  const handleFilter = () => {
    setCurrentPage(1);
    fetchUsers(1);
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchUsers(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    fetchUsers(page, newPerPage);
  };

  const updateSearchKeyword = (keyword) => {
    setSearchKeyword(keyword);
  };
  const onSubmit = async (data) => {
    // e.preventDefault();
    const search = data.search || "";
    const industry_id = isIndustry?.value || "";
    // const queryParams = new URLSearchParams({
    //     search: search,
    //     industry_type_id:industry_id,
    //     sortBy: sortConfig.column || '',
    //     sortOrder: sortConfig.order || '',
    // }).toString();
    // navigate(`/subscriptions/temp-sub?${queryParams}`);
    setFilters({ search, industry_id });
    fetchUsers(1, perPage, search, industry_id);
  };

  return (
    <Fragment>
      {loading && <Transparentspinner />}
      <Breadcrumbs
        mainTitle="Users Without Subscription"
        parent="Subscribers"
        title="Users Without Subscription"
      />
      <Card>
        <CardHeader>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <H3>Users Without Subscription List</H3>
          </div>
        </CardHeader>
        <div className="px-4 pb-2">
          <Row className="g-3 align-items-center">
            <Col sm="12" md="5" lg="3" className="pt-3">
              <SearchList
                className="form-control"
                updateSearchKeyword={updateSearchKeyword}
                onEnter={handleFilter}
              />
            </Col>
            <Col sm="12" md="5" lg="3">
              <div style={{ position: "relative" }}>
                <DatePicker
                  className="form-control digits w-100"
                  selectsRange
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(update) => setDateRange(update)}
                  isClearable={!!(startDate || endDate)}
                  monthsShown={2}
                  calendarClassName="parallel-calendar"
                  placeholderText="Select Date Range"
                  dateFormat="dd-MM-yyyy"
                />
              </div>
            </Col>
            <Col sm="12" md="6" lg="3">
              <IndustryFilter
                IsIndustry={isIndustry}
                setIsIndustry={setIsIndustry}
              />
            </Col>
            <Col>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  float: "left",
                }}
              >
                <button
                  className="btn btn-primary mb-2 ms-2"
                  onClick={handleFilter}
                >
                  Filter
                </button>
              </div>
            </Col>
          </Row>
        </div>
        <CardBody>
          {/* <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                        <Row className="ps-3 gap-sm-3 gap-md-2 mb-4 filterGap">
                            <Col sm="12" md='5' lg='2'>
                                <input name='search' className="form-control" placeholder={Search} id="validationCustom01" type="text"  {...register('search')}
                                />
                            </Col>
                            <Col sm="12" md="6" lg="3">
                            <IndustryFilter
                            IsIndustry={isIndustry}
                            setIsIndustry={setIsIndustry}
                            />
                            </Col>
                            <Col sm="12" md="5" lg='1' className="custom-filtrs">
                                <Btn attrBtn={{ color: "primary" }} type="submit">{Filter}</Btn>
                            </Col>
                        </Row>
                    </Form> */}
          <div className="order-history table-responsive">
            <DataTable
              columns={UserwithoutSubDataColumns}
              data={tempList}
              pagination
              paginationServer
              defaultSortAsc
              paginationTotalRows={totalRows}
              paginationDefaultPage={currentPage}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              paginationRowsPerPageOptions={[10, 25, 50, 100]}
              // selectableRows
              onSelectedRowsChange={({ selectedRows }) =>
                console.log(selectedRows)
              }
            />
          </div>

          <Modal isOpen={showPlanModal} centered backdrop="static">
            <ModalHeader>Choose Subscription Plan</ModalHeader>

            <ModalBody>
              <Label className="form-label">Subscription Plan</Label>
              <Input
                type="select"
                value={selectedPlan?.value ?? ""}
                onChange={(e) => {
                  const selected = packageOptions.find(
                    (item) => String(item.value) === e.target.value,
                  );
                  setSelectedPlan(selected || null);
                }}
              >
                <option value="">-- Select a package --</option>
                {packageOptions.map((pkg) => (
                  <option key={pkg.value} value={pkg.value}>
                    {pkg.label}
                  </option>
                ))}
              </Input>
            </ModalBody>

            <ModalFooter>
              <Button color="secondary" onClick={handleCancel}>
                Back
              </Button>

              <Button
                color="primary"
                onClick={handleConfirmPlan}
                disabled={!selectedPlan}
              >
                Continue
              </Button>
            </ModalFooter>
          </Modal>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default CompanyCreatedListTable;
